import { call, put, takeEvery } from 'redux-saga/effects';
import {
  receiveCustomizeLastQuestion,
  receiveCustomizeLastQuestionError,
  requestCustomizeLastQuestion,
} from '../../services/actions/customizeActions';
import {
  fetchUserAvatarError,
  fetchUserAvatarSuccess,
  USER,
} from '../../services/actions/userActions';
import { getUserAvatar } from '../../services/api/account';
import { getCustomizeLastQuestion } from '../../services/api/sale';

const { FETCH_USER_AVATAR_REQUEST } = USER;

export function* fetchUserAvatar() {
  try {
    const data = yield call(getUserAvatar);
    yield put(fetchUserAvatarSuccess(data && data.userAvatarUrl));
  } catch (error) {
    yield put(fetchUserAvatarError(error));
  }
}

export function* fetchCustomizeLastQuestion() {
  try {
    yield put(requestCustomizeLastQuestion());
    const data = yield call(getCustomizeLastQuestion);
    yield put(receiveCustomizeLastQuestion(data.id, data.experimentInfo));
  } catch (error) {
    yield put(receiveCustomizeLastQuestionError(error));
  }
}

// watcher sagas

export function* watchFetchBaseData() {
  yield takeEvery(FETCH_USER_AVATAR_REQUEST, fetchUserAvatar);
}
